export default __webpack_public_path__ + "static/media/CustomerJourney.b9c0f634.svg";